import React from 'react'
import { ProductInfo } from '../../../utils/chats/ChatFunctions'
import "./ScrollProductsImages.css"
import { ProductDB } from '../../../redux/slices/components/Products/ProductsSlice'
import ScrollProductImageCard from './ScrollProductImageCard/ScrollProductImageCard'
import { ProductImageDB } from '../../../redux/slices/components/ProductsImages/ProductsImagesSlice'

type ScrollProductsImagesProps = {
    sliderData: ProductImageDB[]
}

const ScrollProductsImages = ({ sliderData }: ScrollProductsImagesProps) => {
    return (
        <div className="p-relative flex-1">
            <div className="ml-20 con-scroll-product-cards aux-scroll">
                {
                    sliderData.map((product, index) => {
                        if(index === 0){
                            return (
                                <div key={index}></div>
                            )
                        }
                        return(
                            <ScrollProductImageCard key={index} product={product} />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default React.memo( ScrollProductsImages )